import { themes } from '../Theme/initThemes';
import layout1Settings from './Layout1/Layout1Settings';


export const MatxLayoutSettings = {
  activeLayout: 'layout1', // layout1, layout2
  activeTheme: 'blue', // View all valid theme colors inside Theme/themeColors.js
  perfectScrollbar: true,

  themes,
  layout1Settings
};
